import React from 'react'
import { Frame, ScalingContainer } from './ContainerStyled'
import { useResize } from './useResize'

interface ContProps {
  children: JSX.Element | JSX.Element[]
  unBlur: boolean
  textColor?: string
  backgroundColor?: string
  noFadeIn?: boolean
  styles?: any
  cursor?: 'none' | 'auto'
  height?: string
  width?: string
  top?: string
  right?: string
  left?: string
  padding?: string
}

export default function Container({
  children,
  unBlur,
  textColor,
  backgroundColor,
  noFadeIn,
  styles,
  cursor,
  height,
  width,
  top,
  left,
  right,
  padding,
}: ContProps) {
  const [intViewportHeight, scrollable] = useResize()
  return (
    <Frame
      className='Frame'
      unBlur={unBlur}
      scrollable={scrollable}
      textColor={textColor}
      backgroundColor={backgroundColor}
      noFadeIn={noFadeIn}
      cursor={cursor}
      height={height}
      width={width}
      top={top}
      left={left}
      right={right}
    >
      <ScalingContainer
        style={styles}
        className='ScalingContainer'
        h={intViewportHeight}
        cursor={cursor}
        height={height}
        width={width}
        padding={padding}
      >
        {children}
      </ScalingContainer>
    </Frame>
  )
}
